import BaseServiceCrud from './BaseServiceCrud';

export default class UserAgreementMapService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'user-agreement-map';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc
        });
    }

    getPermissionOpt(transFileObjectName, translate) {
        return this.fetch(`${this.domain}/${this.path}/permission-opt-list`, {
            method: 'GET',
        }).then((res) => {
            res.forEach((element) => {
                element.label = translate(`${transFileObjectName}.${element.permissionType}`);
            });
            return Promise.resolve(res);
        }).catch((err) => {
            throw err;
        });
    }

    delete(element) {
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'DELETE',
            body: JSON.stringify(element),
        }).then((res) => {
            return Promise.resolve(res);
        }).catch((err) => {
            throw err;
        });
    }
}
